<template>
  <div>
    <el-table
      size="mini"
      :data="tableData"
      border
      style="width: 100%;margin-top: 10px"
      highlight-current-row>
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        min-width="60"
        align="center">
      </el-table-column>
<!--      <el-table-column-->
<!--        label="性别"-->
<!--        width="50"-->
<!--        align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{getSex(scope.row.sex)}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="birthday"-->
<!--        label="出生日期"-->
<!--        min-width="70"-->
<!--        align="center">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="phone"
        label="电话号码"
        min-width="90"
        align="center">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90"
        align="center">
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryfamilypersonbyhid} from '../../../api/organizer'

export default {
  name: 'familyContact',
  model: {
    prop: 'familyShow',
    event: 'change'
  },
  props: {
    familyData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: []
    }
  },
  created () {
    this.getFamilyTable()
    // console.log(this.familyData)
  },
  methods: {
    getFamilyTable () {
      let data = {
        orgid: this.familyData.voiceRow.oid,
        hid: this.familyData.detailsMsg.hid
      }
      queryfamilypersonbyhid(data).then(res => {
        this.tableData = res.data.familypersons
      }).catch(() => {})
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/familyContact.vue